/**
 *
 * Asynchronously loads the component for ExperimentTemplates
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ExperimentTemplatesPage = lazyLoad(
  () => import('./index'),
  module => module.ExperimentTemplatesPage,
);
